// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--3Sq9I","primary":"styles-module--primary--1c_aS"};